import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/AuthContext";
import { ContentProvider } from "@/lib/content";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Pricing from "@/pages/Pricing";
import BirthdayCalculator from "@/pages/BirthdayCalculator";
import PortfolioPage from "@/pages/PortfolioPage";
import TestimonialsPage from "@/pages/TestimonialsPage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ContentProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/portfolio/:category" element={<PortfolioPage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/birthday-calculator" element={<BirthdayCalculator />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </ContentProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
